<template>
  <div class="json-tree">
    <div class="json-viewer">
      <tree :data="json" :options="treeOptions" @node:selected="selectNode">
        <span :class="['viewer-type--' + node.data.type]" class="viewer-item" slot-scope="{ node }">
          <span
            class="viewer-item__key"
            v-if="node.hasChildren()"
            v-tooltip.right="node.data.description"
          >
            <span class="viewer-item__key">
              {{ node.text }}
              <span class="viewer-item__array" v-if="node.data.array">[ ]</span>
            </span>
            :
            <span class="viewer-item__ref"><a :href="baseUrl + '#' + node.data.id" target="_blank" v-if="node.data.id">{{ node.data.objectKey }}</a></span>
            <span v-if="node.collapsed()">
              <template v-if="node.data.type == 'array'">[ {{ node.children.length }} ]</template>
              <template v-else>{ {{ node.children.length }} }</template>
            </span>
          </span>
          <span class="viewer-item__prop" v-else v-tooltip.right="node.data.description">
            <span class="viewer-item__key">
              {{ node.text }}
              <span class="viewer-item__array" v-if="node.data.array">[ ]</span>
            </span>
            :
            <span class="viewer-item__value_bold">
              <template v-if="node.text == 'apiVersion'">"{{ node.data.version }}"</template>
              <template v-if="node.text == 'kind'">"{{ node.data.kind }}"</template>
            </span>
            <span class="viewer-item__value">
              <template v-if="node.text != 'kind' && node.text != 'apiVersion'">{{ node.data.objectKey }}</template>
            </span>

          </span>
        </span>
      </tree>
    </div>
    <!-- <div class="json-description">说明
      <div class="attr-description" ref="attr-description"></div>
    </div>-->
  </div>
</template>

<script>
import Vue from 'vue'
import Tooltip from 'vue-directive-tooltip'
import 'vue-directive-tooltip/css/index.css'
import LiquorTree from 'liquor-tree'
import { LiquorData } from '@/common/api-util'
import k8sApi from '@/assets/k8s-api-v1.26.json'

Vue.use(Tooltip)

export default {
  name: 'JsonViewer',
  components: {
    [LiquorTree.name]: LiquorTree
  },
  data() {
    return {
      baseUrl: 'https://kubernetes.io/docs/reference/generated/kubernetes-api/v1.26/',
      json: LiquorData(k8sApi),
      treeOptions: {}
    }
  },

  methods: {
    selectNode(node) {
      //增加其他展示方式
      //this.$refs['attr-description'].innerText = JSON.stringify(node, null, 4)
    },
    isString(value) {
      return 'string' == typeof value
    },

    isNaN(value) {
      return value !== value
    },

    isBoolean(value) {
      return 'boolean' == typeof value
    },

    isNumber(value) {
      return 'number' == typeof value
    },

    isArray(value) {
      return Array.isArray(value)
    },

    isValue(value) {
      return !this.isArray(value) && !this.isPlainObject(value)
    },

    isPlainObject(value) {
      function isObject(obj) {
        return (
          obj != null && typeof obj === 'object' && Array.isArray(obj) === false
        )
      }

      if (
        !isObject(value) ||
        !value.constructor ||
        !value.constructor.prototype
      ) {
        return false
      }

      return (
        value.constructor.prototype.hasOwnProperty('isPrototypeOf') === true
      )
    },

    isIterable(value) {
      return this.isArray(value) || this.isPlainObject(value)
    },

    map(obj, fn) {
      return Object.keys(obj).map(key => {
        return fn(obj[key], key)
      })
    },

    transformObject(prop, key) {
      let obj = {
        text: key
      }

      if (this.isIterable(prop)) {
        obj.children = this.map(prop, this.transformObject)
        obj.data = {
          type: this.isArray(prop)
            ? 'array'
            : this.isPlainObject(prop)
            ? 'object'
            : 'unknown'
        }
      } else {
        obj.data = {
          objectKey: prop || `${prop}`,
          type: this.getType(prop)
        }
      }

      return obj
    },

    getType(value) {
      if (this.isNaN(value)) {
        return 'viewer-type--nan'
      }

      if (this.isString(value)) {
        return 'viewer-type--string'
      }

      if (this.isNumber(value)) {
        return 'viewer-type--integer'
      }

      if (this.isBoolean(value)) {
        return 'viewer-type--boolean'
      }

      if (null === value) {
        return 'viewer-type--null'
      }
    },

    parser(obj) {
      return [
        {
          text: 'JSONObject',
          state: { expanded: true },
          data: { type: 'root' },
          children: this.map(obj, this.transformObject)
        }
      ]
    }
  }
}
</script>
<style>
.viewer-item__key {
  color: #303030;
}

.viewer-item__key,
.viewer-item__ref,
.viewer-item__value {
  padding: 0 3px;
}

.viewer-item__value_bold {
  color: red;
}

.viewer-item__array {
  padding: 0 5px;
}

.viewer-item__ref a {
  text-decoration: none;
}
.viewer-item__ref a:active {
  text-decoration: none;
}

.viewer-type--boolean .viewer-item__value {
  color: #ff9b21;
}

.viewer-type--integer .viewer-item__value {
  color: #f85441;
}

.viewer-type--null .viewer-item__value {
  color: #acabab;
}

.viewer-type--string .viewer-item__value {
  color: green;
}

.viewer-type--object .viewer-item__value {
  color: #8080f5;
}

.vue-tooltip {
  background-color: #f9f9f9;
  color: #000;
  max-width: 600px;
}

.vue-tooltip[x-placement^='right'] .tooltip-arrow {
  border-right-color: #f9f9f9;
}

.tooltip-content {
  line-height: 1.5;
  font-size: 14px;
}
</style>
